module.exports = __webpack_public_path__ + "static/interior_right_s-9f4385f3b77ad676fd3384ddf4a2ed58.webp";